import React, { createContext, useContext, useMemo, useState } from 'react';

export const messages = {
    en: {
        school_donations: 'School Donations',
        disconnect_wallet: 'Disconnect wallet',
        logout_title: 'Log Out',
        logout_body: 'This will disconnect your wallet from this app. You can reconnect any time.',
        my_donations: '📜 My Donations',
        cancel: 'Cancel',
        disconnect: 'Disconnect',
        connect_title: 'TON Wallet',
        connect_body: 'Connect your TON wallet (Tonkeeper, MyTonWallet, Tonhub) to make fast and secure blockchain-based donations. Your seed phrase never leaves your wallet app.',
        amount_label: 'Amount:',
        custom_amount_label: 'Custom amount: (TON)',
        custom_amount_placeholder: 'Enter amount',
        comment_label: 'Comment: (optional)',
        comment_placeholder: 'Note...',
        donate_button: 'Donate',
        connect_wallet_button: 'Connect wallet',
        donation_target_not_found: 'Donation target not found',
        back_button: 'Back',
        transaction_submitted: 'Transaction submitted',
        transaction_submitted_desc: 'Wallet approval is complete. TON network confirmation may take a moment.',
        amount_summary: 'Amount:',
        message_hash: 'Message hash:',
        open_tonviewer: 'Open in Tonviewer',
        record_saved: 'Donation record saved.',
        record_saving: 'Saving donation record...',
        record_failed: 'Transaction submitted. Donation record could not be saved.',
        history_disabled: 'Transaction submitted. Donation history is not configured, so this record was not saved.',
        tx_rejected: 'Transaction rejected',
        wallet_verification_required: 'Please reconnect your wallet from Telegram before donating.',
        loading: 'Loading...',
        my_donations_title: 'My Donations',
        no_donations: 'No donations yet',
        first_donation: 'Make your first donation',
        totals_by_recipient: 'Totals by recipient',
        history_label: 'History',
        donate_again: '🎁 Donate again',
        donations_count_one: 'donation',
        donations_count_other: 'donations',
        open_via_telegram: 'Open this page from Telegram to see your donations.',
        open_via_telegram_short: 'Please open via Telegram',
        load_failed: 'Failed to load donations',
        mydonations_status_confirmed: '✅ Confirmed',
        mydonations_status_pending: '⏳ Pending',
        mydonations_status_mismatch: '⚠️  Mismatch',
        mydonations_status_unverified: '❔ Unverified',
        mydonations_status_check_failed: '⚠️  Check failed',
        admin_title: 'Donation Admin',
        admin_token_placeholder: 'Admin token',
        admin_load: 'Load',
        admin_check_pending: 'Check pending',
        admin_search_placeholder: 'Search school, wallet, or hash',
        admin_all_statuses: 'All statuses',
        admin_copy_hash: 'Copy hash',
        admin_check_onchain: 'Check on-chain',
        admin_empty: 'No donation records loaded.',
        admin_copied: 'Copied',
        admin_token_required: 'Admin token required',
        admin_load_failed: 'Failed to load records',
        admin_unauthorized: 'Unauthorized — token cleared',
        admin_check_failed: 'Confirmation failed',
        admin_checked_count: 'Checked {count} record(s)',
        admin_field_amount: 'Amount',
        admin_field_submitted: 'Submitted',
        admin_field_recorded: 'Recorded',
        admin_field_wallet: 'Wallet',
        admin_field_message: 'Message',
        admin_field_transaction: 'Transaction',
        admin_status_submitted: 'Submitted',
        admin_status_confirmed: 'Confirmed',
        admin_status_not_found: 'Not found',
        admin_status_mismatch: 'Mismatch',
        admin_status_unverified: 'Unverified',
        admin_status_check_failed: 'Check failed',
    },
    ko: {
        school_donations: '학교 기부',
        disconnect_wallet: '지갑 연결 해제',
        logout_title: '연결 해제',
        logout_body: '이 앱에서 지갑 연결을 해제합니다. 언제든 다시 연결할 수 있습니다.',
        my_donations: '📜 내 기부 내역',
        cancel: '취소',
        disconnect: '연결 해제',
        connect_title: 'TON 지갑',
        connect_body: 'Tonkeeper, MyTonWallet, Tonhub 등 TON 지갑을 연결해 빠르고 안전한 블록체인 기부를 진행하세요. 시드 문구는 절대 지갑 앱을 벗어나지 않습니다.',
        amount_label: '금액:',
        custom_amount_label: '직접 입력: (TON)',
        custom_amount_placeholder: '금액을 입력하세요',
        comment_label: '메모: (선택)',
        comment_placeholder: '메모를 남겨주세요...',
        donate_button: '기부하기',
        connect_wallet_button: '지갑 연결',
        donation_target_not_found: '수혜처를 찾을 수 없습니다',
        back_button: '뒤로',
        transaction_submitted: '트랜잭션이 전송되었습니다',
        transaction_submitted_desc: '지갑 승인이 완료되었습니다. TON 네트워크 컨펌까지 잠시 걸릴 수 있습니다.',
        amount_summary: '금액:',
        message_hash: '메시지 해시:',
        open_tonviewer: 'Tonviewer에서 보기',
        record_saved: '기부 내역이 저장되었습니다.',
        record_saving: '기부 내역 저장 중...',
        record_failed: '트랜잭션은 전송되었으나 내역 저장에 실패했습니다.',
        history_disabled: '트랜잭션은 전송되었으나 기부 내역 저장 기능이 설정되어 있지 않습니다.',
        tx_rejected: '트랜잭션이 거부되었습니다',
        wallet_verification_required: '기부하기 전에 텔레그램에서 지갑을 다시 연결해 주세요.',
        loading: '불러오는 중...',
        my_donations_title: '내 기부 내역',
        no_donations: '아직 기부 내역이 없습니다',
        first_donation: '첫 기부 시작하기',
        totals_by_recipient: '수혜처별 합계',
        history_label: '기부 내역',
        donate_again: '🎁 다시 기부',
        donations_count_one: '건',
        donations_count_other: '건',
        open_via_telegram: '텔레그램에서 이 페이지를 열어야 기부 내역을 볼 수 있습니다.',
        open_via_telegram_short: '텔레그램에서 다시 열어 주세요',
        load_failed: '기부 내역을 불러오지 못했습니다',
        mydonations_status_confirmed: '✅ 확정',
        mydonations_status_pending: '⏳ 대기 중',
        mydonations_status_mismatch: '⚠️  불일치',
        mydonations_status_unverified: '❔ 미검증',
        mydonations_status_check_failed: '⚠️  확인 실패',
        admin_title: '기부 관리자',
        admin_token_placeholder: '관리자 토큰',
        admin_load: '불러오기',
        admin_check_pending: '대기 건 확인',
        admin_search_placeholder: '학교/지갑/해시 검색',
        admin_all_statuses: '전체 상태',
        admin_copy_hash: '해시 복사',
        admin_check_onchain: '온체인 확인',
        admin_empty: '불러온 기부 내역이 없습니다.',
        admin_copied: '복사됨',
        admin_token_required: '관리자 토큰이 필요합니다',
        admin_load_failed: '내역을 불러오지 못했습니다',
        admin_unauthorized: '인증 실패 — 토큰을 초기화했습니다',
        admin_check_failed: '확인에 실패했습니다',
        admin_checked_count: '{count}건을 확인했습니다',
        admin_field_amount: '금액',
        admin_field_submitted: '제출 시각',
        admin_field_recorded: '기록 시각',
        admin_field_wallet: '지갑',
        admin_field_message: '메시지',
        admin_field_transaction: '트랜잭션',
        admin_status_submitted: '제출됨',
        admin_status_confirmed: '확정',
        admin_status_not_found: '미발견',
        admin_status_mismatch: '불일치',
        admin_status_unverified: '미검증',
        admin_status_check_failed: '확인 실패',
    },
};

const isLocale = (value) => value === 'en' || value === 'ko';

const detectInitialLocale = () => {
    if (typeof window === 'undefined') return 'en';
    try {
        const urlLang = new URLSearchParams(window.location.search).get('lang');
        if (isLocale(urlLang)) {
            try { window.localStorage?.setItem('lang', urlLang); } catch {}
            return urlLang;
        }
        const stored = window.localStorage?.getItem('lang');
        if (isLocale(stored)) return stored;
        const tg = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
        if (typeof tg === 'string' && tg.toLowerCase().startsWith('ko')) return 'ko';
        if (typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('ko')) {
            return 'ko';
        }
    } catch {}
    return 'en';
};

const interpolate = (template, params) =>
    template.replace(/\{(\w+)\}/g, (_, name) =>
        Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : `{${name}}`
    );

const I18nContext = createContext({ locale: 'en', t: (key) => key });

export const I18nProvider = ({ children }) => {
    const [locale] = useState(detectInitialLocale);
    const value = useMemo(
        () => ({
            locale,
            t: (key, params = {}) => {
                const template = messages[locale]?.[key] ?? messages.en[key] ?? key;
                return params && Object.keys(params).length ? interpolate(template, params) : template;
            },
        }),
        [locale]
    );
    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useT = () => useContext(I18nContext);
